import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { CONCIERGE_ALLOWED_EMAILS } from '@/components/admin/AdminLayout';

/**
 * Concierge is temporarily restricted to a single owner account.
 * Everyone else is redirected away rather than shown an error.
 */
export function ConciergeGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth() as any;
  if (loading) return null;
  const email = (user?.email ?? '').toLowerCase();
  if (!CONCIERGE_ALLOWED_EMAILS.includes(email)) {
    return <Navigate to="/app/admin" replace />;
  }
  return <>{children}</>;
}
